import { atom } from 'jotai';

import { bookingDetailsQueryAtom } from '../_graphql/queryBookingDetails';
import { customerPortalRoutes } from '../routes';
import { BookingDetailsTab } from '../types';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

// 🟣🟣🟣 PARAMS
const $bookingDetailsParams = atomFromRoutePath(
  customerPortalRoutes.bookingDetails,
);
export const $bookingId = atom((get) => get($bookingDetailsParams)?.bookingId);
export const $tab = atomFromQueryString.string<BookingDetailsTab>('tab');

// 🟢🟢🟢 REMOTE DATA
export const $bookingDetails = bookingDetailsQueryAtom((get) => ({
  variables: { id: get($bookingId) },
  skip: !get($bookingId),
}));
